// The home jurisdiction remembered for a signed-in user, in the browser's
// local storage: the default the page reads when the address names none. The
// account profile has no such field; a server-side one would follow the user
// across browsers.

import { toCountryCode } from "./valueChainState";

const KEY_PREFIX = "aa.valueChain.home.";

// The storage key of one user's home jurisdiction
export const homeMemoryKey = (userId: string | number): string =>
  `${KEY_PREFIX}${userId}`;

// The home jurisdiction remembered for a user; null without a user, without
// one remembered, or where the storage cannot be read
export const rememberedHome = (
  userId: string | number | null | undefined,
): string | null => {
  if (userId === null || userId === undefined || userId === "") {
    return null;
  }
  try {
    return toCountryCode(window.localStorage.getItem(homeMemoryKey(userId)));
  } catch {
    return null;
  }
};

// Remembers a user's home jurisdiction, or forgets it when it is null.
// Without a user, or where the storage cannot be written, nothing is kept.
export const rememberHome = (
  userId: string | number | null | undefined,
  home: string | null,
): void => {
  if (userId === null || userId === undefined || userId === "") {
    return;
  }
  try {
    if (home) {
      window.localStorage.setItem(homeMemoryKey(userId), home);
    } else {
      window.localStorage.removeItem(homeMemoryKey(userId));
    }
  } catch {
    // A full or blocked storage keeps nothing; the address still does
  }
};
